const MealsMenusFiles = () => import("./views/MealsMenusFiles.vue");
const MealsMenusFileEdit = () => import("./views/MealsMenusFileEdit.vue");

const route = "/mealsMenusFiles";

export default [
  {
    path: route,
    name: "mealsMenusFiles.list",
    component: MealsMenusFiles,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${route}/:mealsMenuFileId/edit`,
    name: "mealsMenusFiles.edit",
    component: MealsMenusFileEdit,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${route}/create`,
    name: "mealsMenusFiles.create",
    component: MealsMenusFileEdit,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },
];
